// EVENTS.VIEWS.APP.REWARDS.REDEEM.DEFAULT_REDEEM

export const DEFAULT_REDEEM = {
  PAGE_VISITED: 'redeem-page_visited'
};
